import { render } from "./BaseTemplate.vue?vue&type=template&id=5bf0ffe0&scoped=true"
import script from "./BaseTemplate.vue?vue&type=script&lang=ts"
export * from "./BaseTemplate.vue?vue&type=script&lang=ts"

import "./BaseTemplate.vue?vue&type=style&index=0&id=5bf0ffe0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5bf0ffe0"

export default script